import { TimesheetUpdatedByTypeEnum } from '@/constants/timesheet';

function mapTimesheetUpdatedByType(timesheet: any): string {
  return TimesheetUpdatedByTypeEnum[
    timesheet.updatedByType as TimesheetUpdatedByTypeEnum
  ];
}

export { mapTimesheetUpdatedByType };
